import { Link } from 'react-router-dom';

const heroBgImage = 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20artistic%20composition%20of%20colorful%20manga%20and%20comic%20book%20panels%20floating%20in%20a%20dreamy%20atmosphere%2C%20warm%20orange%20and%20pink%20gradient%20background%2C%20dynamic%20action%20lines%2C%20japanese%20and%20Korean%20comic%20art%20elements%2C%20soft%20bokeh%20effects%2C%20cinematic%20lighting%2C%20no%20text%2C%20abstract%20artistic%20style&width=1600&height=900&seq=hero-bg-comic-01&orientation=landscape';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src={heroBgImage}
        alt="皮皮喵漫画 - 热门漫画免费在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl font-bold text-white font-heading drop-shadow-lg">
          皮皮喵漫画
        </h1>
        <p className="mt-4 md:mt-4 text-base md:text-lg text-white/90 max-w-2xl drop-shadow-md leading-relaxed">
          汇集海量<strong>韩漫</strong>、<strong>日漫</strong>、<strong>国漫</strong>与热门<strong>系列漫画大全</strong>，高清在线免费看，分类齐全，随时追更你喜欢的类型漫画
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/korean"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 shadow-lg shadow-primary-500/30 hover:shadow-primary-500/50 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-white/20 backdrop-blur-sm text-white font-medium text-sm border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}